import angular from 'angular';
import syncScheduleComponent from './syncSchedule.component';
import agentConfigService from './agentConfig.service';

let syncScheduleModule = angular.module('syncSchedule', [])
  .component('syncSchedule', syncScheduleComponent)
  .service('agentConfigService', agentConfigService);


export default syncScheduleModule;



// WEBPACK FOOTER //
// ./app/components/syncSchedule/syncSchedule.js